import { configureStore } from "@reduxjs/toolkit";
import { surveyReducer } from "./pages/Survey/Survey.slice";

const store = configureStore({
  reducer: {
    survey: surveyReducer,
  },
});

export default store;